const cartDataKey = 'mobile_counter_cart_data';

function hasCart() {
    const cartData = localStorage.getItem(cartDataKey);
    if (cartData) { 
        const data = JSON.parse(cartData);
        if (data.length > 1) {
            return false
        }
        return true;
    }

    return false;
}

function setCartData(data) {
    localStorage.setItem(cartDataKey, JSON.stringify(data));
}

function getUserCartData() {
    const cartData = localStorage.getItem(cartDataKey);

    if (cartData) {
        const data = JSON.parse(cartData);
        if(data.length > 0){
            return data;
        } else {
            return null
        }

    }

    return null;
}

function clearCartData() {
    localStorage.removeItem(cartDataKey);
}

export default {
    hasCart,
    setCartData,
    getUserCartData,
    clearCartData,
};
